import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

/** NP20-1285: Speichern-Modal vor dem Export, im Look des Vorlagen-Modals. */
@Component({
  selector: 'app-export-save-dialog',
  imports: [MatFormField, MatInput, MatIcon, TranslatePipe],
  templateUrl: './export-save-dialog.component.html',
  styleUrl: './export-save-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportSaveDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() name = '';
  @Output() nameChange = new EventEmitter<string>();
  @Input() maxLength?: number;
  @Output() saved = new EventEmitter<void>();
  @Output() exportWithoutSaving = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  get canSave(): boolean {
    return !!this.name?.trim();
  }

  onNameInput(event: Event): void {
    this.name = (event.target as HTMLInputElement).value;
    this.nameChange.emit(this.name);
  }

  save(): void {
    if (!this.canSave) return;
    this.saved.emit();
  }

  cancel(): void {
    this.cancelled.emit();
    this.close();
  }

  private close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }
}
